<script module lang="ts">
  const blogPostContextKey = Symbol('blog-post-context');
  type BlogPostContext = { value: ExpandedBlogPostStoryBlok };
  const createBlogContext = (value: ExpandedBlogPostStoryBlok) => {
    const runeReference = $state({ value });
    setContext(blogPostContextKey, runeReference);
    return runeReference;
  };
  export const getBlogPostContext = (): BlogPostContext | undefined =>
    hasContext(blogPostContextKey) ? getContext(blogPostContextKey) : undefined;
</script>

<script lang="ts">
  import {
    StoryblokComponent,
    storyblokEditable,
    type SbBlokKeyDataTypes,
  } from '@storyblok/svelte';
  import { getContext, hasContext, setContext } from 'svelte';
  import type { ExpandedBlogPostStoryBlok } from '$lib/server/expanders/blogPostExpander';

  const { blok }: { blok: ExpandedBlogPostStoryBlok } = $props();
  const runeRef = createBlogContext(blok);
  $effect(() => {
    runeRef.value = blok;
  });

  function elementAction(node: HTMLDivElement) {
    return storyblokEditable(node, blok as Record<string, SbBlokKeyDataTypes>);
  }
</script>

<div use:elementAction>
  {#each blok.body ?? [] as item (item._uid)}
    <StoryblokComponent blok={item} />
  {/each}
</div>
